import { jsx as _jsx } from "react/jsx-runtime";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { defaults } from "../shared/defaults";
import menuLink from "../shared/menuLinkWithoutIcons";
import footerTop from "./footerTop";
const React = require("react");
export const collectionSearchUrl = (term)=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${term}`;
const loginUrl = ()=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/my-account/checkouts/physical-materials?directLogin=true`;
const searchPlaceholderImage = {
    src: '/bkw/images/flevo/logo.svg',
    alt: 'Logo FlevoMeer Bibliotheek',
    width: "165",
    height: "60"
};
const flevo = {
    ...defaults,
    menuLink,
    footerTop,
    collectionSearchUrl,
    loginUrl,
    features: {
        autoHyphenate: false,
        manualHyphenate: false
    },
    logo: ()=>/*#__PURE__*/ _jsx("img", {
            width: "231",
            height: "83",
            src: "/bkw/images/flevo/logo.svg",
            alt: "FlevoMeer Bibliotheek logo",
            "aria-hidden": "true"
        }),
    primaryColor: '#FF7320',
    copy: {
        forms: {
            loadingFailed: 'Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met De Bibliotheek FlevoMeer.'
        },
        vacancies: {
            noVacanciesFound: `Op dit moment zijn er helaas geen vacatures beschikbaar.
        Maar dat wil niet zeggen dat jij niets voor de bibliotheek kunt betekenen.
        Stuur ons dus vooral jouw contactgegevens en cv.
        Wellicht hebben we binnenkort wél een geschikte vacature!`
        }
    }
};
export default flevo;
